// Module
var code = "<strong>Fertigung</strong> ";
// Exports
module.exports = code;